import * as _ from 'underscore'

import { Enums } from '../../models/common'
import { OpTask, OpTechnicalPermission } from '../../models/core'

import { ColumnModel } from '../../modules/api/api.models'

import { GridService, GRID_SERVICE_NAME } from '../grid'
import { TechnicalPermissionService, TECHNICAL_PERMISSION_SERVICE_NAME } from '../technical-permission'

import { TaskService, TASK_SERVICE_NAME } from './task.service'


//#region Consts

export const TASK_TECHNICAL_PERMISSIONS_SERVICE_NAME: string = 'TaskTechnicalPermissionsService'
export const TASK_TECHNICAL_PERMISSIONS_SERVICE_PROVIDER_NAME: string = 'TaskTechnicalPermissionsServiceProvider'

//#endregion

export class TaskTechnicalPermissionsService {

    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Task.TechnicalPermissions]' }

    //#endregion


    //#region Ctor

    constructor(
        private gridService: GridService,
        private taskService: TaskService,
        private technicalPermissionService: TechnicalPermissionService
    ) { }

    //#endregion


    //#region Columns

    public getTechnicalPermissionsColumns(): ColumnModel[] {
        return this.technicalPermissionService.getTechnicalPermissionsGridColumns()
    }

    //#endregion


    //#region Save

    public saveTechnicalPermissionsToTask(task: OpTask, addedTechnicalPermissions: OpTechnicalPermission[], removedTechnicalPermissions: OpTechnicalPermission[]): JQueryPromise<OpTask> {
        const taskToSave: OpTask = new OpTask(null)

        taskToSave.idTask = task.idTask
        taskToSave.opState = Enums.OpChangeState.Modified
        taskToSave.technicalPermissions = []

        _.forEach(addedTechnicalPermissions, (addedTechnicalPermission: OpTechnicalPermission) => {
            const clonedOperator: OpTechnicalPermission = addedTechnicalPermission.clone()

            clonedOperator.opState = Enums.OpChangeState.New

            taskToSave.technicalPermissions.push(clonedOperator)
        })

        _.forEach(removedTechnicalPermissions, (removedTechnicalPermission: OpTechnicalPermission) => {
            const clonedOperator: OpTechnicalPermission = removedTechnicalPermission.clone()

            clonedOperator.opState = Enums.OpChangeState.Delete

            taskToSave.technicalPermissions.push(clonedOperator)
        })

        const removedOperatorIds: number[] = removedTechnicalPermissions.map((removedTechnicalPermission: OpTechnicalPermission) => removedTechnicalPermission.idTechnicalPermission)

        task.technicalPermissions
            .filter((loadedTechnicalPermission: OpTechnicalPermission) => !_.include(removedOperatorIds, loadedTechnicalPermission.idTechnicalPermission))
            .forEach((loadedTechnicalPermission: OpTechnicalPermission) => {
                const clonedTechnicalPermission = loadedTechnicalPermission.clone()

                clonedTechnicalPermission.opState = Enums.OpChangeState.Loaded

                taskToSave.technicalPermissions.push(clonedTechnicalPermission)
            })

        return this.taskService.saveTask(taskToSave)
    }

    public saveTechnicalPermissionsGridEditResult(task: OpTask, addedGridItems: any[], removedGridItems: any[]): JQueryPromise<OpTask> {
        const addedTechnicalPermissions: OpTechnicalPermission[] = _.map(addedGridItems, (addedGridItem: any) => {
            const technicalPermission: OpTechnicalPermission = new OpTechnicalPermission(null)

            technicalPermission.idTechnicalPermission = addedGridItem.id

            return technicalPermission
        })

        const removedTechnicalPermissions: OpTechnicalPermission[] = _.map(removedGridItems, (removedGridItem: any) => {
            const technicalPermission: OpTechnicalPermission = new OpTechnicalPermission(null)

            technicalPermission.idTechnicalPermission = removedGridItem.id

            return technicalPermission
        })

        return this.saveTechnicalPermissionsToTask(task, addedTechnicalPermissions, removedTechnicalPermissions)
    }

    //#endregion
}

export class TaskTechnicalPermissionsServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        GRID_SERVICE_NAME,
        TASK_SERVICE_NAME,
        TECHNICAL_PERMISSION_SERVICE_NAME,
        function (
            gridService: GridService,
            taskService: TaskService,
            technicalPermissionsService: TechnicalPermissionService
        ) {
            return new TaskTechnicalPermissionsService(gridService, taskService, technicalPermissionsService)
        }]

    //#endregion
} 